export const category = [
    { id: 0, name: "All" },
    { id: 1, name: "Classical" },
    { id: 2, name: "Country" },
    { id: 3, name: "Electronic" },
    { id: 4, name: "Dance-Pop" },
    { id: 5, name: "Hip-Hop" },
    { id: 6, name: "Jazz" },
    { id: 7, name: "Metal" },
    { id: 8, name: "Pop" },
    { id: 9, name: "R&B" },
    { id: 10, name: "Reggae" },
    { id: 11, name: "Rock" },
];